module.exports = __webpack_public_path__ + "assets/img/00062.9171ec4f.png";